import React, { useState, useEffect } from 'react'
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import { HashRouter, Route, Switch } from 'react-router-dom'
import Footer from "./components/Footer";
import Error from "./pages/Error";
import PreLoader from './components/PreLoader';


function App() {
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
  }, [])

  if (loading) {
    return <PreLoader />
  }
  return (
    <HashRouter>
      <Navbar />
      <Switch>
        <Route path='/' exact>
          <Home />
        </Route>
        <Route path='*'>
          <Error />
        </Route>
      </Switch>
      <Footer />
    </HashRouter>
  );
}

export default App;
